import { API_ROOT } from "@/api/client";

export interface InvitationCard {
    id: number;
    email: string;
    company_name: string;
    project_name: string;
    state: string;
    expires_at: string | false;
}

async function call<T>(path: string, method = "GET", body?: unknown): Promise<T> {
    const response = await fetch(`${API_ROOT}${path}`, {
        method,
        credentials: "same-origin",
        headers: {
            Accept: "application/json",
            ...(body === undefined ? {} : { "Content-Type": "application/json" }),
            ...(method === "GET" ? {} : { "X-Mk-Client": "promaster-react" }),
        },
        body: body === undefined ? undefined : JSON.stringify(body),
    });
    const payload = await response.json();
    if (!response.ok || payload?.error) {
        throw Object.assign(new Error(payload?.error?.message ?? response.statusText), {
            code: payload?.error?.code ?? String(response.status),
            status: response.status,
            details: payload?.error?.details,
        });
    }
    return payload.data as T;
}

export interface WorkspaceContext {
    signed_in: boolean;
    is_org_admin: boolean;
    org_type: string;
    is_owner_org: boolean;
    is_org_representative: boolean;
    org_name: string;
    can_switch_company: boolean;
    presence: "online" | "away" | "offline";
    /** fingerprint of the installed server pack; a change means this app is stale */
    build: string;
}

export const onboardingApi = {
    context: () => call<WorkspaceContext>("/workspace/context"),

    invitation: (token: string) =>
        call<InvitationCard>(`/invitations/${encodeURIComponent(token)}`),

    accept: (token: string, values: {
        manager_name?: string;
        password: string;
        phone?: string;
    }) => call<{ accepted: boolean; next: string; project_name: string }>(
        `/invitations/${encodeURIComponent(token)}/accept`, "POST", values),

    decline: (token: string) => call<{ declined: boolean }>(
        `/invitations/${encodeURIComponent(token)}/decline`, "POST", {}),
};
